import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../project-constants';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {RegionService} from '../../general-services/service-region-anagraf/region-service.service';
import {RegionModel} from '../../../models/RegionModel';
import * as toastr from 'toastr';
import {LocalCustomerSettingsModel} from '../../../models/LocalCustomerSettingsModel';
import {LocalCustomerModel} from '../../../models/LocalCustomerModel';
import {ContractTypeModel} from '../../../models/ContractTypeModel';
import {ResourcesUnitModel} from '../../../models/ResourcesUnitModel';
import {AllSettingsFilterModel} from '../../../models/AllSettingsFilterModel';
import {CurrencyModel} from '../../../models/CurrencyModel';
import {ProviderModel} from '../../../models/ProviderModel';
import {DesignServicesModel} from '../../../models/DesignServicesModel';
import {Router} from '@angular/router';
import {ContractualDataModel} from '../../../models/ContractualDataModel';
import {LoaderService} from '../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-region-anagraf',
  templateUrl: './region-anagraf.component.html',
  styleUrls: ['./region-anagraf.component.scss']
})
export class RegionAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy, OnChanges {

  filter: RegionModel;
  filterInSettings: LocalCustomerSettingsModel;
  filterAllInSettings: AllSettingsFilterModel;
  contractFilter: ContractualDataModel;

  displayedColumns: Array<string>;
  dataSource: any;
  isAnagraphSection: boolean;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  offset: Offset;
  pageSize: number;
  initAfterOnChange: boolean;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @Input() showActions?: boolean;
  @Input() inLocalCustomerSettings?: boolean;
  @Input() inAllSettings?: boolean;
  @Input() idSelected?: number;
  @Input() inAllContractMonth?: boolean;
  @Input() multipleSelection?: boolean;

  @Input() contractTypeForFilterInSettings?: ContractTypeModel;
  @Input() localCustomerForFilterInSettings?: LocalCustomerModel;
  @Input() resourceUnitForFilterInSettings?: ResourcesUnitModel;
  @Input() designServicesForFilterInSettings?: DesignServicesModel;
  @Input() currencyForFilterInSettings?: CurrencyModel;
  @Input() providerForFilterInSettings?: ProviderModel;

  @Input() localCustomerListForFilterInSettings?: Array<LocalCustomerModel>;
  @Input() contractTypeListForFilterInSettings?: Array<ContractTypeModel>;
  @Input() providerListForFilterInSettings?: Array<ProviderModel>;

  @Input() regionSelectedList?: Array<RegionModel>;

  @Input() numAnnoMeseFromForFilterInSettings?: number;
  @Input() numAnnoMeseToForFilterInSettings?: number;

  @Output() elementSelected = new EventEmitter();


  constructor(private regionService: RegionService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.isAnagraphSection = ProjectConstants.returnIsAnagraphSection(this.router.url);
    this.showActions = true;
    this.multipleSelection = false;
    this.filter = new RegionModel();
    this.offset = new Offset();
    this.initAfterOnChange = false;
  }

  ngOnChanges (changes: SimpleChanges) {
    if ('localCustomerForFilterInSettings' in changes
      || 'contractTypeForFilterInSettings' in changes
      || 'resourceUnitForFilterInSettings' in changes
      || 'designServicesForFilterInSettings' in changes
      || 'currencyForFilterInSettings' in changes
      || 'providerForFilterInSettings' in changes
      || 'numAnnoMeseFromForFilterInSettings' in changes
      || 'numAnnoMeseToForFilterInSettings' in changes
      || 'localCustomerListForFilterInSettings' in changes
      || 'contractTypeListForFilterInSettings' in changes
      || 'providerListForFilterInSettings' in changes) {
      this.initAfterOnChange = true;
      this.getAll(this.offset);
    }
  }

  ngOnInit() {
    if (this.showActions === true) {
      // this.displayedColumns = ['regionCod', 'regionDesc', 'inLocalCustomerSetting', 'isShared', 'actions'];
      this.displayedColumns = ['regionCod', 'regionDesc', 'inLocalCustomerSetting', 'actions'];
    } else {
      if (this.multipleSelection) {
        // this.displayedColumns = ['isSelected', 'regionCod', 'isShared', 'regionDesc'];
        this.displayedColumns = ['isSelected', 'regionCod', 'regionDesc'];
      } else {
        // this.displayedColumns = ['regionCod', 'regionDesc', 'isShared'];
        this.displayedColumns = ['regionCod', 'regionDesc'];
      }
    }

    this.pageSize = +this.PAGINATOR.PAGE_SIZE_ARRAY[0];


    this.setOffsetInSession();
    if (!this.initAfterOnChange) {
      this.getAll(this.offset);
    }
  }

  getAll(offset: Offset) {
    this.loaderService.display(true);
    if (this.inLocalCustomerSettings) {
      this.filterInSettings = new LocalCustomerSettingsModel(null,
        this.localCustomerForFilterInSettings,
        this.filter);
      this.getPageSubscribe = this.regionService.getPageInLocalCustomerSettings(offset, this.filterInSettings)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    } else if (this.inAllSettings) {
      this.filterAllInSettings = new AllSettingsFilterModel();

      this.filterAllInSettings.localCustomer = this.localCustomerForFilterInSettings;
      this.filterAllInSettings.resourceUnit = this.resourceUnitForFilterInSettings;
      this.filterAllInSettings.contractType = this.contractTypeForFilterInSettings;
      this.filterAllInSettings.provider = this.providerForFilterInSettings;
      this.filterAllInSettings.region = this.filter;

      this.filterAllInSettings.localCustomerList = this.localCustomerListForFilterInSettings;
      this.filterAllInSettings.contractTypeList = this.contractTypeListForFilterInSettings;
      this.filterAllInSettings.providerList = this.providerListForFilterInSettings;

      this.getPageSubscribe = this.regionService.getPageInAllSettings(offset, this.filterAllInSettings)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.setChecked();
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    } else if (this.inAllContractMonth) {
      this.contractFilter = new ContractualDataModel();
      this.contractFilter.numAnnoMeseFrom = this.numAnnoMeseFromForFilterInSettings;
      this.contractFilter.numAnnoMeseTo = this.numAnnoMeseToForFilterInSettings;
      this.contractFilter.provider = this.providerForFilterInSettings;
      this.contractFilter.resourceUnit = this.resourceUnitForFilterInSettings;
      this.contractFilter.localCustomer = this.localCustomerForFilterInSettings;
      this.contractFilter.contractType = this.contractTypeForFilterInSettings;
      this.contractFilter.region = this.filter;

      this.getPageSubscribe = this.regionService.getPageInAllContractMonth(offset, this.contractFilter)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    } else {
      this.getPageSubscribe = this.regionService.getPage(offset, this.filter)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    }
  }

  filterTable() {
    this.getAll(new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0));
  }

  resetTable() {
    this.filter = new RegionModel();
    this.getAll(new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0));
  }

  openDialog(id: number) {
    const regionData = this.dataSource.find(data => data.id === id) as RegionModel;
    const list: GenericArray[] = [
      { id: 'Region Cod', value: regionData.cod.toString() },
      { id: 'Region Description', value: regionData.description.toString() },
      { id: 'Is Shared', value: regionData.isShared.toString() },
    ];

    if (regionData.isShared) {
      const region1Obj = regionData.sharedRegionObj.region1Obj as RegionModel;
      const region2Obj = regionData.sharedRegionObj.region2Obj as RegionModel;
      list.push(
        { id: 'Shared Region 1', value: region1Obj.description.toString() },
        { id: 'Shared Region 2', value: region2Obj.description.toString() }
       );
    }
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getAll(this.offset);

  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.deleteElementSubscribe = this.regionService.softDelete(id)
        .subscribe(
          (result: any) => {
            if (result) {
              toastr.success('Region with id ' + id + ' was deleted with success', 'Success');
              this.getAll(this.offset);
            } else {
              toastr.info('Region cannot be deleted', 'Alert');
            }

          }, error =>  {
            this.loaderService.display(false);
            toastr.error('Region with id ' + id + ' was not deleted', 'Error');
          }
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.dataSource = dataFiltered.content;
    this.listData = new MatTableDataSource(this.dataSource);
    this.paginator.pageIndex = this.offset.pageIndex;
    this.paginator.length = dataFiltered.totalElements;

  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getAll(this.offset);
    }
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  selectRow(row: any) {
    if (!this.multipleSelection) {
      this.elementSelected.emit({ row });
    }
  }

  selectMultipleRow(row: any) {
    this.elementSelected.emit({ row });
  }

  setOffsetInSession(newOffset?: Offset) {
    if (newOffset) {
      sessionStorage.setItem('regionOffset', JSON.stringify(newOffset));
    } else {
      const sessionOffset = sessionStorage.getItem('regionOffset');
      this.offset = sessionOffset !== 'undefined' && sessionOffset !== null ? JSON.parse(sessionOffset) : new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      this.pageSize = this.offset.pageSize;
    }
  }

  setChecked() {
    if (this.regionSelectedList && this.regionSelectedList.length > 0) {
      for (let _i = 0; _i < this.dataSource.length; _i++) {
        const region: RegionModel = this.dataSource[_i];
        for (let _j = 0; _j < this.regionSelectedList.length; _j++) {
          if (region.id ===  this.regionSelectedList[_j].id) {
            region.checked = true;
          }
        }
      }
    }
  }
}
